class WishlistManager {
  constructor() {
    this.wishlistToggles = document.querySelectorAll(".wishlist-toggle");
    this.quickViewButtons = document.querySelectorAll(".quick-view-button");
    this.customerToken = window.customerToken;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.wishlistToggles.forEach((toggle) => {
      toggle.addEventListener("click", (e) => this.handleWishlistToggle(e));
    });

    this.quickViewButtons.forEach((button) => {
      button.addEventListener("click", (e) => this.handleQuickView(e));
    });
  }

  handleQuickView(event) {
    const button = event.currentTarget;
    const handle = button.dataset.handle;
    const url = `/products/${handle}`;

    // Get quick add drawer
    const quickAddDrawer = document.querySelector("quick-add-drawer");
    if (quickAddDrawer) {
      button.dataset.productUrl = url;

      // Simulate click event that the drawer listens for
      const clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      // Add required class and data attribute
      button.classList.add("js-quick-add");

      // Dispatch click event
      button.dispatchEvent(clickEvent);
    }
  }

  async handleWishlistToggle(event) {
    if (!this.customerToken) {
      window.location.href = "/account/login";
      return;
    }

    const button = event.currentTarget;
    const productId = button.dataset.productId;
    const isAdded = button.dataset.wishlistAdded === "true";

    try {
      const response = await fetch(
        "https://wholesale-account-registration.nw.r.appspot.com/wishlist/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Customer-Token": this.customerToken,
          },
          body: JSON.stringify({
            productId,
            action: isAdded ? "remove" : "add",
          }),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Failed to update wishlist");
      }

      if (isAdded) {
        // If we're removing from wishlist, find and remove the card
        const wishlistItem = button.closest(".wishlist-item");
        if (wishlistItem) {
          // Add fade-out animation
          wishlistItem.style.transition = "opacity 0.3s ease-out";
          wishlistItem.style.opacity = "0";

          // Wait for animation to complete before removing
          setTimeout(() => {
            wishlistItem.remove();

            // Check if wishlist is empty and show message if needed
            const remainingItems = document.querySelectorAll(".wishlist-item");
            if (remainingItems.length === 0) {
              const wishlistGrid = document.querySelector(".wishlist-grid");
              if (wishlistGrid) {
                wishlistGrid.innerHTML = "<p>Your wishlist is empty</p>";
              }
            }
          }, 300);
        }
      }

      // Update any other instances of this product's wishlist button
      this.updateButtonState(button, !isAdded);
      document
        .querySelectorAll(`.wishlist-toggle[data-product-id="${productId}"]`)
        .forEach((btn) => this.updateButtonState(btn, !isAdded));
    } catch (error) {
      console.error("Error updating wishlist:", error);
    }
  }

  updateButtonState(button, isAdded) {
    const icon = button.querySelector(".wishlist-icon");
    button.dataset.wishlistAdded = isAdded.toString();

    if (isAdded) {
      icon.classList.add("active");
      icon.setAttribute("fill", "currentColor");
    } else {
      icon.classList.remove("active");
      icon.setAttribute("fill", "none");
    }

    // Update all other instances of this product's wishlist button
    const productId = button.dataset.productId;
    document
      .querySelectorAll(`.wishlist-toggle[data-product-id="${productId}"]`)
      .forEach((btn) => {
        if (btn !== button) {
          const btnIcon = btn.querySelector(".wishlist-icon");
          btn.dataset.wishlistAdded = isAdded.toString();
          if (isAdded) {
            btnIcon.classList.add("active");
            btnIcon.setAttribute("fill", "currentColor");
          } else {
            btnIcon.classList.remove("active");
            btnIcon.setAttribute("fill", "none");
          }
        }
      });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new WishlistManager();
});
